import { render, staticRenderFns } from "./ErrorModal.vue?vue&type=template&id=73572f66&scoped=true"
import script from "./ErrorModal.vue?vue&type=script&lang=js"
export * from "./ErrorModal.vue?vue&type=script&lang=js"
import style0 from "./ErrorModal.vue?vue&type=style&index=0&id=73572f66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73572f66",
  null
  
)

export default component.exports